import * as React from 'react';
import { Component } from 'react';
import DANG_KY from "../../const/dang-ky";

import ThongTinTuyenSinh from './ThongTinTuyenSinh';
import swal from "sweetalert2";
import KhachHangService from "../../services/khachHang";

import { DANH_MUC } from '../../const/danh-muc';

class FormDangKy extends Component<any, any> {
  constructor(props) {
    super(props);
    this.state = {
      hoTen: '',
      hoTenHocSinh: '',
      ngaySinh: '',
      diaChi: '',
      email: '',
      dienThoai: '',
      chuongTrinh: '',
      chuongTrinhQuanTam: '',
      CoSoQuanTam: '',
      isThamQuan: true,
    }
  }
  private dang_ky = false;


  componentDidMount() {
  };


  dangKy() {
    let error = false;
    if (this.dang_ky) {
      return;
    } else {
      this.setState({
        er_null: false,
        er_em: false,
        er_sv: false,
        success: false,
      })

      // if (this.state.hoTen.trim() == '' 
      // || this.state.hoTenHocSinh.trim() == '' 
      // || this.state.ngaySinh.trim() == '' 
      // || this.state.diaChi.trim() == '' 
      // || this.state.dienThoai.trim() == '' 
      // || this.state.email.trim() == '' 
      // || this.state.chuongTrinh.trim() == '' 
      // || this.state.chuongTrinhQuanTam.trim() == '' 
      // || this.state.CoSoQuanTam.trim() == '') 
      if (this.state.hoTen.trim() == '' 
      || this.state.ngaySinh.trim() == '' 
      || this.state.dienThoai.trim() == '' 
      || this.state.email.trim() == '' 
      || this.state.chuongTrinh.trim() == '' 
      || this.state.CoSoQuanTam.trim() == '') {
        swal({
          title: "Note",
          text: "Please fill out the form completely",
          type: "warning"
        });
        error = true;
      }
      else {
        let s =
          /(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))/g;
        let exp: RegExp = new RegExp(s);
        if (!exp.test(this.state.email)) {
          swal({
            title: "Note",
            text: "Email invalidate (abc@abc.com)",
            type: "warning"
          });
          error = true;
        }
        let n =
          /^([0-2][0-9]|(3)[0-1])(\/)(((0)[0-9])|((1)[0-2]))(\/)\d{4}$/i;
        let exp2: RegExp = new RegExp(n);
        if (!exp2.test(this.state.ngaySinh)) {
          swal({
            title: "Note",
            text: "Incorrect date of birth (dd/mm/yyyy)",
            type: "warning"
          });
          error = true;
        }
      }

      if (error == true) {
        return;
      }

      let values: any = {
        hoTen: this.state.hoTen,
        danhMucId: Number(this.state.chuongTrinh),
        diaChi: this.state.diaChi,
        soDienThoai: this.state.dienThoai,
        email: this.state.email,
        others: {
          ngay_sinh: this.state.ngaySinh,
          is_tham_quan: this.state.isThamQuan,
          chuong_trinh_quan_tam: Number(
            this.state.chuongTrinhQuanTam
          ),
          ho_ten_hoc_sinh: this.state.hoTenHocSinh,
          co_so_quan_tam: this.state.CoSoQuanTam
        }
      };
      this.dang_ky = false

      KhachHangService.dangKy(values)
        .then(() => {
          this.dang_ky = false
          this.setState({
            hoTen: '',
            hoTenHocSinh: '',
            ngaySinh: '',
            diaChi: '',
            email: '',
            dienThoai: '',
            chuongTrinh: '',
            chuongTrinhQuanTam: '',
            CoSoQuanTam: '',
            isThamQuan: true,
          });
          swal({
            title: "Success",
            text: 'Thank you for registering',
            type: "success"
          });
        })
        .catch(() => {
          this.dang_ky = false
          swal({
            title: "Error",
            text: "Having trouble registering, please re-register",
            type: "error"
          });
        });
    }
  }
  handleChange(e) {
    var name = e.target.name;
    var value = e.target.value;
    this.setState({
      [name]: value,
      error: e.target.validationMessage,

    })
  }
  useState(arg0: Date): [any, any] {
    throw new Error('Function not implemented.');
  }


  onChange = date => this.setState({ date })

  render() {
    // const [startDate, setStartDate] =new Date();
    return (


      <div className="block  back-dangky" id="dangky">
        {/* {this.modal()} */}
        <div className="container">
          <div className="row contentdangky">
            <div className="col-sm-12 text-center block-title text-white">SIGNING UP FOR CONSULTATION AND SCHOOL VISIT</div>
            <div className="col-sm left">
              <ThongTinTuyenSinh />
            </div>
            <div className="col-sm-7">
              <div className="block-dangky">
                <div className="box-dangky">
                  
                  <div>
                    <input
                      name="hoTen"
                      type="text"
                      placeholder="Full name"
                      className="form-control"
                      value={this.state.hoTen}
                      onChange={(event) => this.handleChange(event)}
                    />
                  </div>
                  <div className='hide'>
                    <input
                      name="hoTenHocSinh"
                      type="text"
                      placeholder="Full name student"
                      className="form-control"
                      value={this.state.hoTenHocSinh}
                      onChange={(event) => this.handleChange(event)}
                    />
                  </div>
                  <div>
                    <div className="form-group">
                      <input
                        type="text"
                        className="form-control"
                        name="ngaySinh"
                        placeholder="DOB (dd/mm/yyyy)"
                        value={this.state.ngaySinh}
                        onChange={(event) => this.handleChange(event)} />
                    </div>
                  </div>
                  <div className='hide'>
                    <input
                      name="diaChi"
                      type="text"
                      placeholder="Address"
                      className="form-control"
                      value={this.state.diaChi}
                      onChange={(event) => this.handleChange(event)}
                    // ref={ref => (this.inputRef.diaChi = ref)}
                    />
                  </div>
                  <div>
                    <input
                      name="dienThoai"
                      type="text"
                      placeholder="Phone number"
                      className="form-control"
                      value={this.state.dienThoai}
                      onChange={(event) => this.handleChange(event)}
                    // ref={ref => (this.inputRef.dienThoai = ref)}
                    />
                  </div>
                  <div>
                    <input
                      name="email"
                      type="email"
                      placeholder="Email"
                      className="form-control"
                      value={this.state.email}
                      onChange={(event) => this.handleChange(event)}
                    // ref={ref => (this.inputRef.email = ref)}
                    />
                  </div>
                  <div>
                    <select
                      name="CoSoQuanTam"
                      className="form-control"
                      value={this.state.CoSoQuanTam}
                      onChange={(event) => this.handleChange(event)}
                    // ref={ref => (this.inputRef.chuongTrinhQuanTam = ref)}
                    >
                      <option value="" disabled>
                        Campus:
                      </option>
                      <option value={DANH_MUC.COSOPMH}>Phu My Hung Campus</option>
                      <option value={DANH_MUC.COSOPL}>Phu Lam Campus</option>
                    </select>
                  </div>
                  <div>
                    <select
                      name="chuongTrinh"
                      className="form-control"
                      value={this.state.chuongTrinh}
                      onChange={(event) => this.handleChange(event)}
                    // ref={ref => (this.inputRef.chuongTrinh = ref)}
                    >
                      <option value="" disabled>
                        Education stage:
                      </option>
                      {Object.keys(DANG_KY).map(key => (
                        <option key={key} value={DANG_KY[key]}>
                          {key}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className='hide'>
                    <select
                      name="chuongTrinhQuanTam"
                      className="form-control"
                      value={this.state.chuongTrinhQuanTam}
                      onChange={(event) => this.handleChange(event)}
                    // ref={ref => (this.inputRef.chuongTrinhQuanTam = ref)}
                    >
                      <option value="" disabled>
                        Chương Trình Học Quan Tâm
                      </option>
                      <option value={DANH_MUC.CTH_SONG_NGU}>Chương trình Song ngữ quốc tế</option>
                      <option value={DANH_MUC.CTH_HOI_NHAP}>Chương trình hội nhập quốc tế</option>
                      <option value={DANH_MUC.CTH_SUMMER_CAMP}>Chương trình Summer Camp</option>
                    </select>
                  </div>
                  <div className="row" style={{marginLeft: 0, marginRight: 0}}>
                    <div className="col-sm dknopadding">
                      <label className="dknomargin hide">Đăng ký tham quan:</label>
                    </div>
                    <div
                      className="col-sm dknopadding"
                      style={{ display: "flex" }}
                    >
                      <form
                        style={{
                          //display: "inline",
                          display: "none",
                          marginTop: "10px"
                        }}
                        onChange={(event) => this.handleChange(event)}
                      >
                        Có
                        <input
                          type="radio"
                          value="true"
                          name="isThamQuan"
                          style={{ margin: "0 5px" }}
                          defaultChecked
                        />{" "}
                        Không
                        <input
                          type="radio"
                          value="false"
                          name="isThamQuan"
                          style={{ margin: "0 5px" }}
                        />
                      </form>
                    </div>
                    <div className="col-sm-2 dknopadding text-right">
                      <input onClick={() => this.dangKy()} type="button" className=" btn btn-danger border-radius" value="FINISH" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div >
    );
  }
}

export default FormDangKy;
